import { useCallback, useEffect, useMemo, useState } from "react";
import { Box } from "@mui/material";
import { jwtDecode } from "jwt-decode";
import SubAbaImobiliariaFiltro from "../../Filtros/SubAbaImobiliariaFiltro";
import TabelaImobiliaria from "./TabelaImobiliaria";
import { getImobiliarias } from "../../AssistenteVendasGestaoEndPoints";

const ImobiliariaAba = () => {
  const [nomeFilter, setNomeFilter] = useState("");
  const [regiaoFilter, setRegiaoFilter] = useState("");
  const [imobiliariasBase, setImobiliariasBase] = useState([]);
  const [imobiliariasFiltradas, setImobiliariasFiltradas] = useState([]);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    const fetchImobiliarias = async () => {
      setLoading(true);
      try {
        const token = localStorage.getItem("jwtToken");
        if (!token) return;

        const decodedToken = jwtDecode(token);
        const idCliente = decodedToken.id_cliente;

        const dados = await getImobiliarias(idCliente);

        const imobiliariasMapeadas = (dados || []).map((imobiliaria) => ({
          nome: imobiliaria.nomeImobiliaria || imobiliaria.nome || "",
          regiao: imobiliaria.nomeRegiao || imobiliaria.regiao || "",
          idClienteAipim: imobiliaria.idClienteAipim,
        }));

        setImobiliariasBase(imobiliariasMapeadas);
        setImobiliariasFiltradas(imobiliariasMapeadas);
      } catch (error) {
        console.error("Erro ao carregar imobiliarias:", error);
      } finally {
        setLoading(false);
      }
    };

    fetchImobiliarias();
  }, []);

  const filtrarImobiliarias = useCallback(() => {
    const normalize = (value) => (value || "").toString().toLowerCase();

    return imobiliariasBase.filter((imobiliaria) => {
      const nomeMatch = nomeFilter
        ? normalize(imobiliaria.nome).includes(normalize(nomeFilter))
        : true;

      const regiaoMatch = regiaoFilter
        ? normalize(imobiliaria.regiao).includes(normalize(regiaoFilter))
        : true;

      return nomeMatch && regiaoMatch;
    });
  }, [imobiliariasBase, nomeFilter, regiaoFilter]);

  const handleApplyFilters = () => {
    setLoading(true);
    setTimeout(() => {
      setImobiliariasFiltradas(filtrarImobiliarias());
      setLoading(false);
    }, 500);
  };

  const handleClearFilters = () => {
    setNomeFilter("");
    setRegiaoFilter("");
    setLoading(true);
    setTimeout(() => {
      setImobiliariasFiltradas(imobiliariasBase);
      setLoading(false);
    }, 500);
  };

  const regioesDisponiveisMemo = useMemo(() => {
    const todasRegioes = imobiliariasBase.flatMap((imobiliaria) =>
      (imobiliaria.regiao || "")
        .split("|")
        .map((item) => item.trim())
        .filter(Boolean)
    );

    return Array.from(new Set(todasRegioes));
  }, [imobiliariasBase]);

  return (
    <Box sx={{ display: "flex", flexDirection: "column", gap: 2 }}>
      <SubAbaImobiliariaFiltro
        nomeFilter={nomeFilter}
        setNomeFilter={setNomeFilter}
        regiaoFilter={regiaoFilter}
        setRegiaoFilter={setRegiaoFilter}
        regioesDisponiveis={regioesDisponiveisMemo}
        handleApplyFilters={handleApplyFilters}
        handleClearFilters={handleClearFilters}
      />

      <TabelaImobiliaria
        imobiliarias={imobiliariasFiltradas}
        loading={loading}
      />
    </Box>
  );
};

export default ImobiliariaAba;
